import React, { PureComponent } from 'react'
import PropTypes from 'prop-types';

import tagsConfigHelper from '../../../helpers/tagsConfigHelper'

class Div extends PureComponent {
    constructor(props) {
        super(props)

        this.state ={}
        this.initState=this.initState.bind(this)
        this.initControl = this.initControl.bind(this)

        this.initState()
    }

    initState(){
        this.state={
            visible:false
        }
    }

    initControl() {
        let {doctype,tagid}=this.props
        
        if (!doctype || !tagid) return

        var tagInfo = tagsConfigHelper.findTagConfig(tagid, doctype)

            if(tagInfo){
                this.setState({
                    visible:tagInfo.visibled
                })
            }
    }

    componentWillReceiveProps(nextProps) {        
        if (this.props.doctype !== nextProps.doctype) {
               this.initControl()
        }
    }

    componentDidMount() {
        this.initControl()
    }

    render() {
        let { visible } = this.state
        let {tagid}=this.props

        if (this.props.doctype) {
            var tagInfo = tagsConfigHelper.findTagConfig(this.props.tagid, this.props.doctype)
            if (tagInfo) {
                visible = tagInfo.visibled
            }
        }
        return (
           (!tagid || (tagid && visible)) && <div
                {...this.props}
                //style={{ visibility: visible ? "visible" : "hidden" }}
                //style={{ visibility: this.props.viewMode ? "hidden" : "visible" }}
                style={{visibility: this.props.viewMode ? "hidden" : "visible" }}
            />
        )
    }    
}

Div.defaultProps = {
}

Div.propTypes = {
    doctype: PropTypes.string,
    tagid: PropTypes.string
}

export default Div